(() => {
  const data = window.H17_FITMENT_DATA || {};
  const aggregate = values => { const unique = [...new Set(values.filter(Boolean))]; return unique.length === 1 ? unique[0] : unique.length ? 'mixed' : 'notApplicable'; };
  // Vehicle warnings come only from explicit obstruction records; brand alone is not evidence.
  const needsCheck = record => Boolean(record?.bumperCheck || record?.obstructions?.lowerLight);
  window.H17FitmentRules = {
    needsCheck,
    status(record, position, clearance = '') {
      const key = position + 'Light';
      const obstruction = record?.obstructions?.[key];
      if (obstruction && position !== 'lower') return 'incompatible';
      // Clearance or a removal commitment restores only explicitly verified grille eligibility.
      const status = obstruction
        ? obstruction.unobstructedCompatibility || 'unknown'
        : record?.compatibility?.[key] || 'unknown';
      if (position !== 'lower' || status !== 'compatible' || !needsCheck(record)) return status;
      return ['clear', 'remove'].includes(clearance) ? status : clearance === 'blocked' ? 'incompatible' : 'unknown';
    },
    reason(record, position, clearance = '') {
      if (record?.bumperPart) return record.reason;
      if (position !== 'lower' || !needsCheck(record)) return record?.obstructions?.[position + 'Light']?.reason || ''; 
      if (clearance === 'blocked') return 'A bumper or guard crosses your lower grille. The Lower Spot Pro kit is not compatible while that obstruction is installed.';
      if (clearance === 'remove') return 'You confirmed the obstruction has been removed or will be removed. The lower grille opening must be clear before installing the Lower Spot Pro kit.';
      if (clearance === 'unsure') return 'Contact Hangar 17 with a front photo of your sled so we can review bumper clearance before you order the lower kit.';
      if (clearance !== 'clear') return record?.obstructions?.lowerLight
        ? 'This model is flagged for a possible Explorer² front-bumper obstruction. Check your sled and select an answer below before ordering the lower kit.'
        : 'Check your front bumper before ordering. An Explorer² bumper or another guard crossing the lower grille blocks the Lower Spot Pro kit, even when the grille matches.';
      return '';
    },
    part(partNumber) {
      const number = String(partNumber || '').match(/\d{6,}/)?.[0];
      const bumper = data.obstructionParts?.[number];
      if (bumper) return {partNumber:number,roles:[],bumperPart:true,name:bumper.name,reason:bumper.reason,compatibility:{lowerLight:bumper.status,upperLight:'unknown'},ambiguous:false};
      const indices = data.partIndex?.[number];
      if (!indices?.length) return null;
      const roles = new Set(), lower = [], upper = []; let bumperCheck = false;
      for (const i of indices) {
        const c = data.configurations[i];
        for (const [role,numbers] of Object.entries(c.components || {})) {
          if (!numbers.includes(number)) continue;
          const group = role.startsWith('lowerGrille') ? 'lowerGrille' : role.startsWith('upperGrille') ? 'upperGrille' : null;
          if (!group) continue;
          roles.add(group);
          const position = group === 'lowerGrille' ? 'lowerLight' : 'upperLight';
          const status = c.componentCompatibility?.[role]?.[number] || c.compatibility?.[position] || 'unknown';
          (position === 'lowerLight' ? lower : upper).push(status);
          if (position === 'lowerLight' && c.obstructions?.lowerLight && status === 'compatible') bumperCheck = true;
        }
      }
      const compatibility = {lowerLight:aggregate(lower),upperLight:aggregate(upper)};
      return {partNumber:number,roles:[...roles],compatibility,bumperCheck,ambiguous:Object.values(compatibility).includes('mixed')};
    }
  };
})();
